import { render, staticRenderFns } from "./form3.vue?vue&type=template&id=bb98e600&scoped=true&"
import script from "./form3.vue?vue&type=script&lang=js&"
export * from "./form3.vue?vue&type=script&lang=js&"
import style0 from "./form3.vue?vue&type=style&index=0&id=bb98e600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb98e600",
  null
  
)

export default component.exports